import createVueApp from '../../shared/vue/create-app';
import shared from '../../shared';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initCustomControls from '../../components/custom-controls';
import initSideMenuComponents from '../../components/side-menu';
import {initWizardComponents} from '../../components/wizard/wizard';
import initMarkdownEditorComponent from '../../components/markdown/markdown-editor';
import initWizardAdvertStepsComponents from '../../components/wizard/wizard-advert-steps';
import {initLoginComponents} from '../../components/login';
import initAddressSelectorComponent from '../../components/inputs/address-selector';
import initMarkdownViewerComponent from '../../components/markdown/markdown-viewer';
import VueMultiselectExtended from '../../components/inputs/multiselect';
import {initCurrencyPriceComponents} from '../../components/inputs/currency-price';
import initAutocompleteComponent from '../../components/map/autocomplete';
import initEditableInputComponent from '../../components/inputs/editable-input';
import initPhoneInputComponent from '../../components/inputs/phone-input';
import initGaTrackerComponent from '../../components/ga-tracking';
import initFileUploaderComponent from '../../components/inputs/file-uploader';
import initVideoUploaderComponent from '../../components/inputs/video-uploader';
import initOpenHoursComponent from '../../components/open-hours';
import initEmailInput from '../../components/inputs/email-input';
import initAdvertPreviewComponent from '../../components/advert-preview';
import {initCascadeModals} from '../../components/modals/cascade-modals';

const initWizardPage = (data) => {
    const app = createVueApp({ // NOSONAR
        components: {
            Multiselect: VueMultiselectExtended,
        },
    });

    app.component('multiselect', VueMultiselectExtended);

    initCustomInputsComponents(app);
    initCustomControls(app);
    initSideMenuComponents(app);
    initWizardComponents(app);
    initMarkdownEditorComponent(app);
    initWizardAdvertStepsComponents(app);
    initLoginComponents(app);
    initAddressSelectorComponent(app);
    initMarkdownViewerComponent(app);
    initCurrencyPriceComponents(app);
    initAutocompleteComponent(app);
    initEditableInputComponent(app);
    initPhoneInputComponent(app);
    initGaTrackerComponent(app);
    initFileUploaderComponent(app);
    initVideoUploaderComponent(app);
    initOpenHoursComponent(app);
    initEmailInput(app);
    initAdvertPreviewComponent(app);
    initCascadeModals(app);

    app.mount('#app');
};

export {shared, initWizardPage};
